import { render, staticRenderFns } from "./Completa.vue?vue&type=template&id=79d8aeee&scoped=true&"
import script from "./Completa.vue?vue&type=script&lang=js&"
export * from "./Completa.vue?vue&type=script&lang=js&"
import style0 from "./Completa.vue?vue&type=style&index=0&id=79d8aeee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8aeee",
  null
  
)

export default component.exports